import React from "react";

export const PDFPreview = ({ url }) => {
  const fallack = url.includes("api.envd.integritysystems.com.au") ? (
    <a href={url} target="_blank" rel="noreferrer">
      Click here to open the eNVD pdf in a new tab
    </a>
  ) : (
    "Can&apos;t be rendered"
  );

  return url ? (
    <object className="flex-1" data={url} key={url}>
      {fallack}
    </object>
  ) : null;
};
